import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from 'src/common/services/auth/auth.service';
import { SettingService } from 'src/common/services/setting/setting.service';
import { MyActionPipeService } from 'src/services/action/action.service';

@Component({
  selector: 'app-pending-deals-card',
  templateUrl: './pending-deals-card.component.html',
  styleUrls: ['./pending-deals-card.component.scss']
})
export class PendingDealsCardComponent implements OnInit {


  constructor(
    protected afs: AngularFirestore,
    public auth: AuthService,
    public setting: SettingService,
    public deals: MyActionPipeService,
  ) {
  }

  ngOnInit(): void {
    this.deals.subscribe();
  }

  calculTotal(element: any): number {
    let total = 0;
    if (element.mandate.realtor === this.auth.uid) {
      total = total + element.mandateCA;
    }
    if (element.project.realtor === this.auth.uid) {
      total = total + element.projectCA;
    }
    return total;
  }
}
